export const getActiveUsers = params => dispatch => {
    window.axios.get('/api/analytics-users').then(response => {
        dispatch({
            type: 'GET_ACTIVE_USERS',
            payload: response.data.activeUsers
        });
    });
};



// WEBPACK FOOTER //
// ./src/actions/analytics.js